import { trEnv } from 'ion-lib';

const pages = [
  {
    path: '/',
    name: 'Vorschaltseite',
    title: 'Produktauswahl',
    breadcrumb: false,
    buttons: {
      next: false,
      prev: false,
      save: false,
    },
    active: trEnv.stationaer,
  },
  {
    path: '/prepage',
    name: 'Prepage',
    title: null,
    breadcrumb: false,
    buttons: {
      next: true,
      prev: false,
      save: false,
    },
    active: trEnv.stationaer,
  },
  {
    path: '/',
    name: 'Prepage',
    title: 'Hausratversicherung',
    breadcrumb: false,
    buttons: {
      next: true,
      prev: false,
      save: false,
    },
    active: trEnv.ifiliale,
  },
  {
    path: '/',
    name: 'ErsteDaten',
    title: 'Ihr Zuhause',
    breadcrumb: true,
    buttons: {
      next: true,
      prev: false,
      save: false,
    },
    active: !trEnv.sparkasse,
  },
  {
    path: '/erstedaten',
    name: 'ErsteDaten',
    title: 'Ihr Zuhause',
    breadcrumb: true,
    buttons: {
      next: true,
      prev: false,
      save: trEnv.sparkasse,
    },
    active: trEnv.sparkasse,
  }, {
    path: '/produktvergleich',
    name: 'Produktvergleich',
    title: trEnv.sparkasse ? 'Produktauswahl' : 'Ihr Angebot',
    breadcrumb: true,
    buttons: {
      next: false,
      prev: true,
      save: trEnv.sparkasse,
    },
    active: true,
  },
  {
    path: '/personendaten',
    name: 'Personendaten',
    title: 'Persönliche Daten',
    breadcrumb: true,
    buttons: {
      next: true,
      prev: true,
      save: trEnv.sparkasse,
    },
    active: true,
  },
  {
    path: '/vorversicherung',
    name: 'Vorversicherung',
    title: 'Vorversicherung',
    breadcrumb: true,
    buttons: {
      next: true,
      prev: true,
      save: trEnv.sparkasse,
    },
    active: true,
  },
  {
    path: '/zahlungsdaten',
    name: 'Zahlungsdaten',
    title: trEnv.stationaer ? 'Zahlungsdaten' : 'Zahlung und Datenschutz',
    breadcrumb: true,
    buttons: {
      next: true,
      prev: true,
      save: trEnv.sparkasse,
    },
    active: true,
  },
  {
    path: '/euberatung/angaben',
    name: 'AngabenGespraech',
    title: 'Beratungsdokumentation (1 von 2)',
    breadcrumb: true,
    buttons: {
      next: true,
      prev: true,
      save: true,
    },
    active: trEnv.stationaer,
  },
  {
    path: '/euberatung/berater',
    name: 'EmpfehlungBerater',
    title: 'Beratungsdokumentation (2 von 2)',
    breadcrumb: true,
    buttons: {
      next: true,
      prev: true,
      save: true,
    },
    active: trEnv.stationaer,
  },
  {
    path: '/zusammenfassung',
    name: 'Zusammenfassung',
    title: 'Zusammenfassung',
    breadcrumb: true,
    buttons: {
      next: true,
      prev: true,
      save: trEnv.sparkasse,
    },
    active: true,
  },
  {
    path: '/beantragen',
    name: 'Beantragen',
    title: 'Abschluss',
    breadcrumb: true,
    buttons: {
      next: false,
      prev: true,
      save: trEnv.sparkasse,
    },
    active: !trEnv.stationaer,
  },
  {
    path: '/abschluss',
    name: 'Abschluss',
    breadcrumb: false,
    buttons: {
      next: false,
      prev: false,
      save: false,
    },
    active: !trEnv.sparkasse,
  },
  {
    path: '/druckmatrix',
    name: 'Druckmatrix',
    title: 'Drucken',
    breadcrumb: true,
    buttons: {
      next: true,
      prev: true,
      save: true,
    },
    active: trEnv.stationaer,
  },
  {
    path: '/unterschrift',
    name: 'Unterschrift',
    title: 'Freigeben',
    breadcrumb: true,
    buttons: {
      next: true,
      prev: false,
      save: false,
    },
    active: trEnv.stationaer,
  },
];

export default pages;
